import React, { createContext, useState, useEffect, useMemo } from 'react'

export const UIContext = createContext()

export const UIContextProvider = ({ children }) => {
    const [previousPage, setPreviousPage] = useState('')
    const [currentPage, setCurrentPage] = useState('home')
    const [menuOpen, setMenuOpen] = useState(false)
    const [memberModalVisible, setMemberModalVisible] = useState(false)
    const [showIntroLogo, setShowIntroLogo] = useState(true)
    const [selectedMember, setSelectedMember] = useState(null)
    const [memberModalRef, setMemberModalRef] = useState(null)
    const [selectedModal, setSelectedModal] = useState(null)
    const [modalVisible, setModalVisible] = useState(false)
    const [isTablet, setIsTablet] = useState(window.innerWidth < 1025)
    const [isMobile, setIsMobile] = useState(window.innerWidth < 601)

    const checkScreenSize = () => {
        setIsMobile(window.innerWidth < 601)
        setIsTablet(window.innerWidth < 1025)
    }

    useEffect(() => {
        window.addEventListener('resize', checkScreenSize);
        return () => window.removeEventListener('resize', checkScreenSize)
    }, [])

    const value = useMemo(() => ({
        previousPage,
        currentPage,
        menuOpen,
        showIntroLogo,
        isMobile,
        isTablet,
        selectedMember,
        selectedModal,
        memberModalRef,
        memberModalVisible,
        modalVisible,
        setPreviousPage,
        setCurrentPage,
        setMenuOpen,
        setSelectedMember,
        setSelectedModal,
        setShowIntroLogo,
        setMemberModalRef,
        setMemberModalVisible,
        setModalVisible,
    }), [previousPage, currentPage, menuOpen, memberModalRef, modalVisible, memberModalVisible, selectedMember, selectedModal, showIntroLogo, isMobile, isTablet])

    return (
        <UIContext.Provider value={value}>
            {children}
        </UIContext.Provider>
    )
}